export class DropDownMenuClickEvent extends CustomEvent<{
   id: string;
   payload: boolean;
}> {
   static EVENT_NAME = 'menu-click';

   constructor(id: string, payload: boolean) {
      super(DropDownMenuClickEvent.EVENT_NAME, {
         detail: { id, payload },
         bubbles: true,
         composed: true,
      });
   }
}

export class DropDownMenuItemClickEvent extends Event {
   static EVENT_NAME = 'menu-item-click';
   constructor() {
      super(DropDownMenuItemClickEvent.EVENT_NAME);
   }
}
